<div class="embed-responsive embed-responsive-16by9">
    <iframe *ngIf="blog" class="embed-responsive-item" src="https://windowswapblog.squarespace.com/"
        allowfullscreen></iframe>
    <iframe *ngIf="!blog" class="embed-responsive-item" src=" https://windowswapblog.squarespace.com/blog/tipjar"
        allowfullscreen></iframe>
</div>